import React from 'react'
import ReactDOM from 'react-dom'
import {
  extractIndexPosition,
  extractIndexTransformation
} from './utils'

import './style.scss'

export default class VeryNicePortal extends React.PureComponent {
  static defaultProps = {
    isFixed: false, // Position method
    wrapperClassName: null, // Portal wrapper element class
    centerX: true, // Center of render content will be at provided X position, other-wise left
    centerY: true, // Center or render content will be at provider Y position, other-wise top
    position: {
      x: 0,
      y: 0,
      rotate: null,
      translateX: null,
      translateY: null,
      centerX: undefined, // If defined over rides positioning global centering rules.
      centerY: undefined // If defined over rides positioning global centering rules.
    }
  }

  constructor (props) {
    super(props)
    // We can't add a ref to a portal, so we
    // create a new element we can reference.
    // https://reactjs.org/docs/portals.html
    this.el = document.createElement('div')

    // This class name will not be reactive.
    // @TODO Would need a props change check and
    // manually update this element
    if (props.wrapperClassName) {
      this.el.classList.add(...props.wrapperClassName.split(' '))
    }

    this.portalRoot = document.getElementById('app-portal-container');
  }

  componentDidMount () {
    // Attach portal to dom
    if (this.portalRoot) {
      this.portalRoot.appendChild(this.el)
    }
  }

  componentWillUnmount () {
    // Cleanup portal / remove portal from dom
    if (this.portalRoot) {
      this.portalRoot.removeChild(this.el)
    }
  }

  render () {
    const position = this.props.position

    // Quick helper to get child style
    const getExistingStyle = (child) => child
      ? child.props.style || {}
      : {}

    // Clone element and apply position style
    const positionedChildren = React.Children.map(this.props.children, (child, index) =>
      child
        ? React.cloneElement(child, {
            style: {
              ...getExistingStyle(child),
              position: this.props.isFixed ? 'fixed' : 'absolute',
              top: extractIndexPosition(position, index, 'y'),
              left: extractIndexPosition(position, index, 'x'),
              transform: extractIndexTransformation(position, index, {
                centerX: this.props.centerX,
                centerY: this.props.centerY
              })
            }
          })
        : null
    )

    // Render portal
    return ReactDOM.createPortal(positionedChildren, this.el)
  }
}
